export function IconFacebook() {
  return (
    <path
      fill="currentColor"
      d="M35.092 20.09A15.093 15.093 0 1 0 17.642 35V24.453h-3.833V20.09h3.832v-3.325c0-3.782 2.254-5.872 5.7-5.872 1.132.016 2.262.115 3.38.294v3.716h-1.905a2.18 2.18 0 0 0-2.458 2.358v2.83h4.181l-.669 4.362H22.35V35A15.092 15.092 0 0 0 35.092 20.09Z"
    />
  )
}
